module.exports = __webpack_public_path__ + "img/medal_vip2.ffddeb2.png";